import { logToDataDog } from '@/utils/logToDatadog';

export async function checkEligibility(emailToken: string, email: string) {
  try {
    const resp = await fetch('/api/checkEligibility', {
      method: 'POST',
      body: JSON.stringify({ email, emailToken }),
    });
    const response = await resp.json();
    return response;
  } catch (error) {
    await logToDataDog('api', 'Error calling checkEligibility', {
      emailToken,
      error,
    });
  }
}
